<template>
  <v-chip
    :color="colors[status].background"
    :text-color="colors[status].text"
  >
    {{ capitalizeString(status) }}
  </v-chip>
</template>

<script>
// Export the SFC
export default {
  // Name of the component
  name: "StatusChip",

  // Accept incoming data from parent
  props: {
    status: {
      type: String,
      required: true
    }
  },

  // Define local key map store
  data: () => ({
    // Map for status chip colors
    colors: {
      pending: {
        background: "orange lighten-3",
        text: "black"
      },
      aggregating: {
        background: "orange darken-2",
        text: "white"
      },
      processing: {
        background: "blue darken-2",
        text: "white"
      },
      error: {
        background: "red darken-1",
        text: "white"
      },
      done: {
        background: "green darken-1",
        text: "white"
      }
    },
  })
}
</script>
